(function () {
  function moneyFormat(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' kr';
  }

  function getMatchingVariant(slide, variants) {
    var selects = slide.querySelectorAll('[data-upsell-option-index]');
    var selected = [];
    selects.forEach(function (s) {
      selected[parseInt(s.dataset.upsellOptionIndex, 10)] = s.value;
    });

    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;
      for (var j = 0; j < selected.length; j++) {
        if (v.options[j] !== selected[j]) {
          match = false;
          break;
        }
      }
      if (match) return v;
    }
    return null;
  }

  function updateSlideUI(slide) {
    var handle = slide.dataset.productHandle;
    var script = slide.querySelector('[data-upsell-variants="' + handle + '"]');
    if (!script) return;

    var variants;
    try {
      variants = JSON.parse(script.textContent);
    } catch (e) {
      return;
    }

    var variant = getMatchingVariant(slide, variants);
    var priceEl = slide.querySelector('[data-upsell-price]');
    var compareEl = slide.querySelector('[data-upsell-compare]');
    var addBtn = slide.querySelector('[data-upsell-add]');

    if (!variant) {
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = 'Otillgänglig';
      }
      return;
    }

    if (priceEl) priceEl.textContent = moneyFormat(variant.price);
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = moneyFormat(variant.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    if (addBtn) {
      addBtn.dataset.variantId = variant.id;
      if (variant.available) {
        addBtn.disabled = false;
        addBtn.textContent = addBtn.dataset.textDefault || 'Ja tack, lägg till';
      } else {
        addBtn.disabled = true;
        addBtn.textContent = 'Slut i lager';
      }
    }
  }

  function refreshDrawer() {
    var basePath = window.location.pathname;
    var separator = basePath.indexOf('?') === -1 ? '?' : '&';
    fetch(basePath + separator + 'section_id=cart-drawer&_=' + Date.now())
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newDrawer = doc.querySelector('cart-drawer');
        var oldDrawer = document.querySelector('cart-drawer');
        if (newDrawer && oldDrawer) {
          oldDrawer.innerHTML = newDrawer.innerHTML;
          document.dispatchEvent(new CustomEvent('cart:updated'));
        }
      });
  }

  function ensureUpsellOnOpen() {
    var cartIcons = document.querySelectorAll('[href*="/cart"], #cart-icon-bubble, .header__icon--cart, [aria-label*="cart" i], [aria-label*="varukorg" i]');
    cartIcons.forEach(function (icon) {
      if (icon.dataset.upsellRefreshAttached) return;
      icon.dataset.upsellRefreshAttached = 'true';

      icon.addEventListener('click', function () {
        setTimeout(function () {
          var drawer = document.querySelector('cart-drawer');
          var hasItems = drawer && !drawer.classList.contains('is-empty');
          var hasUpsell = !!document.querySelector('[data-cart-upsell]');

          if (hasItems && !hasUpsell) {
            refreshDrawer();
          }
        }, 150);
      });
    });
  }

  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-upsell-option-index]');
    if (!select) return;
    e.stopPropagation();
    var slide = select.closest('[data-upsell-slide]');
    if (slide) updateSlideUI(slide);
  }, true);

  document.addEventListener('input', function (e) {
    if (e.target.matches('[data-upsell-option-index]')) {
      e.stopPropagation();
    }
  }, true);

  document.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-upsell-prev]');
    if (prev) {
      e.preventDefault();
      e.stopPropagation();
      var track1 = prev.parentElement.querySelector('[data-upsell-track]');
      if (track1) track1.scrollBy({ left: -track1.clientWidth, behavior: 'smooth' });
      return;
    }

    var next = e.target.closest('[data-upsell-next]');
    if (next) {
      e.preventDefault();
      e.stopPropagation();
      var track2 = next.parentElement.querySelector('[data-upsell-track]');
      if (track2) track2.scrollBy({ left: track2.clientWidth, behavior: 'smooth' });
      return;
    }

    var addBtn = e.target.closest('[data-upsell-add]');
    if (addBtn) {
      e.preventDefault();
      e.stopPropagation();
      handleAdd(addBtn);
      return;
    }
  }, true);

  function handleAdd(btn) {
    var variantId = btn.dataset.variantId;
    if (!variantId || btn.disabled) return;

    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Lägger till…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1 }]
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Add failed');
        return r.json();
      })
      .then(function () {
        btn.classList.add('is-added');
        btn.textContent = 'Tillagd ✓';
        refreshDrawer();
      })
      .catch(function (err) {
        console.error('Upsell add failed:', err);
        btn.disabled = false;
        btn.textContent = originalText;
        alert('Något gick fel. Försök igen.');
      });
  }

  // === Reservation timer ===
  function startReservationTimer() {
    var banner = document.querySelector('[data-reservation-banner]');
    if (!banner) return;
    var timerEl = banner.querySelector('[data-reservation-timer]');
    if (!timerEl) return;

    if (banner.dataset.timerStarted === 'true') return;
    banner.dataset.timerStarted = 'true';

    var totalSeconds = 10 * 60;
    var intervalId;

    function tick() {
      if (totalSeconds <= 0) {
        banner.classList.add('is-hidden');
        clearInterval(intervalId);
        return;
      }
      var minutes = Math.floor(totalSeconds / 60);
      var seconds = totalSeconds % 60;
      timerEl.textContent = String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0');
      totalSeconds--;
    }

    tick();
    intervalId = setInterval(tick, 1000);
  }

  function watchForBanner() {
    if (document.querySelector('[data-reservation-banner]:not(.is-hidden)')) {
      startReservationTimer();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureUpsellOnOpen);
    document.addEventListener('DOMContentLoaded', watchForBanner);
  } else {
    ensureUpsellOnOpen();
    watchForBanner();
  }

  var observer = new MutationObserver(function () {
    watchForBanner();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();